import { lazy } from 'react';

const InvoicedConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/manager/consults/invoiced-info',
			component: lazy(() => import('./InvoicedContainer'))
		}
	]
};

export default InvoicedConfig;

